import { Button } from '@aws-amplify/ui-react';
import { Box, Typography } from '@mui/material';
import { signInWithRedirect } from 'aws-amplify/auth';
import { Trans } from 'react-i18next';
import { ultraMarine } from '../../utils/colors';
import { amplifyTranslate, amplifyTranslateImpl } from '../amplifyI18n';
import StyledBox from './styles';

export default function SignIn() {
  return (
    <StyledBox>
      <Box>
        <Button
          backgroundColor={ultraMarine[500]}
          isFullWidth
          fontWeight="bold"
          onClick={() => { signInWithRedirect(); }}
          variation="primary"
        >
          Sign in
        </Button>
      </Box>
      <Box>
        <Typography className="conditions" variant="body2">
          <Trans
            i18nKey="accept_conditions.title"
            t={amplifyTranslate}
            components={{
              1: <a href={amplifyTranslateImpl('conditions.link')} target="_blank" rel="noreferrer">Terms and Conditions</a>,
              3: <a href={amplifyTranslateImpl('privacy_policy.link')} target="_blank" rel="noreferrer">Privacy Policy</a>,
            }}
          />
        </Typography>
      </Box>
    </StyledBox>
  );
}
